// English translations
import enCommon from './en/common.json';
import enAuth from './en/auth.json';
import enHeader from './en/header.json';
import enHome from './en/home.json';
import enPuzzles from './en/puzzles.json';
import enCreatePuzzle from './en/create_puzzle.json';
import enPool from './en/pool.json';
import enUserProfile from './en/user_profile.json';
import enRank from './en/rank.json';
import enDesafiosCacatais from './en/desafios_cacatais.json';
import enCacatal from './en/cacatal.json';
import enPuzzleChat from './en/puzzle_chat.json';
import enOther from './en/other.json';
import enDiscussion from './en/discussion.json';
// Portuguese translations
import ptCommon from './pt/common.json';
import ptAuth from './pt/auth.json';
import ptHeader from './pt/header.json';
import ptHome from './pt/home.json';
import ptPuzzles from './pt/puzzles.json';
import ptCreatePuzzle from './pt/create_puzzle.json';
import ptPool from './pt/pool.json';
import ptUserProfile from './pt/user_profile.json';
import ptRank from './pt/rank.json';
import ptDesafiosCacatais from './pt/desafios_cacatais.json';
import ptCacatal from './pt/cacatal.json';
import ptPuzzleChat from './pt/puzzle_chat.json';
import ptOther from './pt/other.json';
import ptDiscussion from './pt/discussion.json';
// Combine English translations
const en = {
  common: enCommon,
  auth: enAuth,
  header: enHeader,
  home: enHome,
  puzzles: enPuzzles,
  create_puzzle: enCreatePuzzle,
  pool: enPool,
  user_profile: enUserProfile,
  rank: enRank,
  desafios_cacatais: enDesafiosCacatais,
  cacatal: enCacatal,
  puzzle_chat: enPuzzleChat,
  other: enOther,
  discussion: enDiscussion,
};

// Combine Portuguese translations
const pt = {
  common: ptCommon,
  auth: ptAuth,
  header: ptHeader,
  home: ptHome,
  puzzles: ptPuzzles,
  create_puzzle: ptCreatePuzzle,
  pool: ptPool,
  user_profile: ptUserProfile,
  rank: ptRank,
  desafios_cacatais: ptDesafiosCacatais,
  cacatal: ptCacatal,
  puzzle_chat: ptPuzzleChat,
  other: ptOther,
  discussion: ptDiscussion,
};

// Export all translations
export default {
  en,
  pt,
};
